<template>
  <div class="card">
    <div class="card-header py-2">
      <b-form-checkbox style="margin-right: 5px" class="display-inline" v-model="checkedAll" :indeterminate="indeterminate" :disabled="trackGroup.tracks.length == 0">
      </b-form-checkbox>
      <span @click="checkedAll = !checkedAll">{{ trackGroup.translate ? $t(trackGroup.translate) : trackGroup.label }}</span>
      <div style="float: right;">
        <img @click="togglePanel" style="height: 13px; cursor: pointer;" :src="iconsVisible ? icons.chevronUp : icons.chevronDown" />
      </div>
    </div>
    <div v-show="iconsVisible" ref="tracks" class="card-body p-2">
      <div>
      {{ $t('tracksSelectedDistance') }}: {{ roundTrackDistance(sumTracksDistance(checkedTracks)) }}
      <img  v-if="calendar" @click="openCalendarModal" style="height: 20px; cursor: pointer; float: right;" :src="icons.calendar" />
      </div>
      <ul>
        <li v-if="countTracksByType(trackGroup.tracks, TrackType.walk) > 0">{{ $t('tracksSelectedDistanceWalk') }} {{ countWalkTracks(checkedTracks) }}: {{ roundTrackDistance(sumTracksDistanceWalk(checkedTracks)) }}</li>
        <li v-if="countTracksByType(trackGroup.tracks, TrackType.bicycle) > 0">{{ $t('tracksSelectedDistanceBicycle') }} {{ countBicycleTracks(checkedTracks) }}: {{ roundTrackDistance(sumTracksDistanceBicycle(checkedTracks)) }}</li>
        <li v-if="countTracksByType(trackGroup.tracks, TrackType.mushroom) > 0">{{ $t('tracksSelectedDistanceMushroom') }} {{ countMushroomTracks(checkedTracks) }}: {{ roundTrackDistance(sumTracksDistanceMushroom(checkedTracks)) }}</li>
      </ul>
      <div v-for="track in trackGroup.tracks" :key="track.gpsTrack.id">
        <AppTrack v-show="showAppTrack(track)" :track="track" :highlightOnStart="highlightOnStart(track)" :showDetails="showDetails"></AppTrack>
        <div v-if="showAppTrack(track)" style="height: 5px; width: 5px;"></div>
      </div>
    </div>

    <div v-if="calendar" ref="calendarModal" class="modal fade" tabindex="-1" role="dialog">
      <info-modal :title="$t('calendar')">
        <template #headerright>
          <div style="margin-left: auto;">
            <img @click="closeCalendarModal" style="height: 25px; cursor: pointer;" :src="icons.closeIcon" />
          </div>
        </template>
        <div style="align-items: center; text-align: center;">
          <template v-for="(index, key) in monthRange" :key="index">
            <div v-if="key % (window.isDesktop ? 3 : 1) == 0" style="display: block; width: 1px; height: 1px;"></div>
            <div :style="{'max-width': window.isDesktop ? '33%' : '100%', 'display': 'inline-block'}">
              <div style="margin: 2px; margin-top: 20px; border: solid 1px; border-color: rgb(240, 240, 240); text-align: center;">
                <div style="text-align: center; margin: 3px"><b>{{ $t('month' + index) }}</b></div>
                <table style="text-align: center" class="table table-sm">
                  <tr>
                    <td class="callendertd"><b>pon</b></td>
                    <td class="callendertd"><b>wto</b></td>
                    <td class="callendertd"><b>śro</b></td>
                    <td class="callendertd"><b>czw</b></td>
                    <td class="callendertd"><b>pią</b></td>
                    <td class="callendertd"><b>sob</b></td>
                    <td class="callendertd"><b>nie</b></td>
                  </tr>
                  <tr v-for="week in getCalendarLabels(index)" :key="week">
                    <td style="border: solid 1px white"  class="callendertd" v-for="day in week" :key="day" :style="{'background-color': day.track ? (isBicycleTrack(day.track.gpsTrack) ? '#6ee05c' : '#5ed9f7') : 'white'}">
                      {{ day.label }}
                    </td>  
                  </tr>    
                </table>  
              </div>
            </div>
          </template>
        </div>  
            
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="closeCalendarModal">
            <strong>{{ $t('close') }}</strong>
          </button>
        </div>
      </info-modal>
    </div>  

  </div>
</template>

<script lang="ts">
import TrackGroup from '@/ts/TrackGroup';
import BaseComponent from './Base.vue';
import Track from '@/ts/Track';
import {EventBus} from '@/ts/EventBus';
import { formatDateDay } from '@/ts/utils';
import { defineComponent, type PropType } from "vue";
import { TrackType } from '@/ts/types';

export default defineComponent({
    extends: BaseComponent,
    data() {
        const iconsVisible: boolean = true;
        const checkedAll: boolean = undefined;

        return {
            checkedAll,
            iconsVisible,
            //@ts-ignore
            TrackType
        };
    },
    computed: {
        allChecked() {
            let oneChecked = false;
            let oneUnChecked = false;
            for (const track of this.trackGroup.tracks) {
              if (track.checked) {
                oneChecked = true;
              } else {
                oneUnChecked = true;
              }
            }
            if (oneChecked && !oneUnChecked) {
              return true;
            }
        },
        allUnChecked() {
            let oneChecked = false;
            let oneUnChecked = false;
            for (const track of this.trackGroup.tracks) {
              if (track.checked) {
                oneChecked = true;
              } else {
                oneUnChecked = true;
              }
            }
            if (!oneChecked && oneUnChecked) {
              return true;
            }
        },
        reverseTracks() {
            return [...this.trackGroup.tracks].reverse();
        },
        firstMonth() {
            if (this.reverseTracks.length) {
              if (this.reverseTracks[0].gpsTrack.start_time) {
                return this.reverseTracks[0].gpsTrack.start_time.getMonth(); 
              } else {
                return 0;
              }
            } else {
              return 0;
            }
        },
        lastMonth() {
            if (this.trackGroup.tracks.length) {
              if (this.trackGroup.tracks[0].gpsTrack.start_time) {
                return this.trackGroup.tracks[0].gpsTrack.start_time.getMonth(); 
              } else {
                return 0;
              }
            } else {
              return 0;
            }
        },
        monthRange() {
            return this.range(this.lastMonth - this.firstMonth + 1, this.firstMonth);
        },
        checkedTracks() {
            const tracks: Track[] = [];
            for (const track of this.trackGroup.tracks) {
              if (track.checked) {
                tracks.push(track);
              }
            }
            return tracks;
        },
        indeterminate() {
            let oneChecked = false;
            let oneUnChecked = false;
            for (const track of this.trackGroup.tracks) {
              if (track.checked) {
                oneChecked = true;
              } else {
                oneUnChecked = true;
              }
            }
            return oneChecked && oneUnChecked;
        }
    },
    created() {
        let oneChecked = false;
        let oneUnChecked = false;
        for (const track of this.trackGroup.tracks) {
          if (track.checked) {
            oneChecked = true;
          } else {
            oneUnChecked = true;
          }
        }
        if (oneChecked && !oneUnChecked) {
          this.checkedAll = true;
        } else {
          this.checkedAll = false;
        }
    },
    mounted() {
        EventBus.$on('expandAllGroups', () => {
          if (! this.iconsVisible) {
            this.togglePanel();
          }
        })
        EventBus.$on('hideAllGroups', () => {
          if (this.iconsVisible) {
            this.togglePanel();
          }
        })
    },
    methods: {
        showAppTrack(track: Track) {
            if (this.searchText.trim()) {
              if (track.gpsTrack.name.toLowerCase().includes(this.searchText.toLowerCase().trim())) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
        },
        range(size: number, startAt: number = 0): ReadonlyArray<number> {
            return [...Array(size).keys()].map(i => i + startAt);
        },
        openCalendarModal() {
            this.openModal(this.$refs.calendarModal);
        },
        closeCalendarModal() {
            this.closeModal(this.$refs.calendarModal);
        },
        getCalendarLabels(month: number) {
            const weeks = [];
            if ((this.trackGroup.tracks.length > 0) && (this.trackGroup.tracks[0].gpsTrack.start_time)) {
              const firstDayOfMonth = new Date(this.trackGroup.tracks[0].gpsTrack.start_time.getFullYear(), month, 1);
              let week = [];
              let firstDay = firstDayOfMonth.getDay() - 1;
              if (firstDay == -1) {
                firstDay = 6;
              }
              const empty = this.range(firstDay);
              for (let index in empty) {
                week.push({'label': '', 'track': false});
              }
              let loopDay = new Date(this.trackGroup.tracks[0].gpsTrack.start_time.getFullYear(), month, 1);
              while(loopDay.getMonth() == month) {
                let wasTrack = null;
                for(let track of this.trackGroup.tracks) {
                  const trackDateWithoutHours = new Date(track.gpsTrack.start_time);
                  trackDateWithoutHours.setHours(0, 0, 0, 0);
                  if ((loopDay.getMonth() == trackDateWithoutHours.getMonth()) && (loopDay.getDate() == trackDateWithoutHours.getDate()) && (loopDay.getFullYear() == trackDateWithoutHours.getFullYear())) {
                    wasTrack = track;
                  }
                }
                week.push({'label': loopDay.getDate(), 'track': wasTrack});
                if (week.length == 7) {
                  weeks.push(week)
                  week = [];
                }
                const newDate = loopDay.setDate(loopDay.getDate() + 1);
                loopDay = new Date(newDate);
              }
              if (week.length > 0) {
                weeks.push(week)
              } 
            }
            return weeks;
        },
        countWalkTracks(tracks: Track[]) {
            let count = 0;
            let countDays = 0;
            let dates: string[] = [];
            for (const track of tracks) {
              if (track.gpsTrack.isWalkTrack()) {
                const dateDay = formatDateDay(track.gpsTrack.start_time);
                if (! (dates.includes(dateDay))) {
                  countDays = countDays + 1;
                  dates.push(dateDay);
                }
                count = count + 1;
              }
            }
            return '(' + count + '/' + countDays + ')';
        },
        countBicycleTracks(tracks: Track[]) {
            let count = 0;
            let countDays = 0;
            let dates: string[] = [];
            for (const track of tracks) {
              if (track.gpsTrack.isBicycleTrack()) {
                const dateDay = formatDateDay(track.gpsTrack.start_time);
                if (! (dates.includes(dateDay))) {
                  countDays = countDays + 1;
                  dates.push(dateDay);
                }
                count = count + 1;
              }
            }
            return '(' + count + '/' + countDays + ')';
        },
        countMushroomTracks(tracks: Track[]) {
            let count = 0;
            let countDays = 0;
            let dates: string[] = [];
            for (const track of tracks) {
              if (track.gpsTrack.isMushroomTrack()) {
                const dateDay = formatDateDay(track.gpsTrack.start_time);
                if (! (dates.includes(dateDay))) {
                  countDays = countDays + 1;
                  dates.push(dateDay);
                }
                count = count + 1;
              }
            }
            return '(' + count + '/' + countDays + ')';
        },
        togglePanel() {
            //$(this.$refs.tracks).slideToggle('slow');
            this.iconsVisible = !this.iconsVisible;
        },
        highlightOnStart(track: Track) {
            if ((! track.onServer) && (track.gpsTrack.distance > 0)) {
              return true;
            } else {
              return false;
            }
        },
        onCheckedAllChanged(value: boolean, oldValue: boolean) {
            if (this.checkedAll) {
              for (const track of this.trackGroup.tracks) {
                this.$store.commit('setTrackChecked', {track, checked: true});
              }
            } else {
              for (const track of this.trackGroup.tracks) {
                this.$store.commit('setTrackChecked', {track, checked: false});
              }
            }
        },
        onallCheckedChanged(value: boolean, oldValue: boolean) {
            if (this.allChecked) {
              this.checkedAll = true;
            }
        },
        onallUnCheckedChanged(value: boolean, oldValue: boolean) {
            if (this.allUnChecked) {
              this.checkedAll = false;
            }
        }
    },
    props: {
        trackGroup: { required: true,
            type: Object as PropType<TrackGroup>
        },
        searchText: { required: true,
            type: String
        },
        calendar: { required: false,
            type: Boolean
        },
        showDetails: { required: true,
            type: Boolean
        }
    },
    watch: {
        "checkedAll": [{
            handler: "onCheckedAllChanged"
        }],
        "allChecked": [{
            handler: "onallCheckedChanged"
        }],
        "allUnChecked": [{
            handler: "onallUnCheckedChanged"
        }]
    }
})


</script>